import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b4ca3d9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b4ca3d9&prod&lang=css"
import style1 from "../scss/index.scss?vue&type=style&index=1&id=0b4ca3d9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ca3d9",
  null
  
)

export default component.exports